export enum CamperDataEnum {
  DEFAULT = "DEFAULT",
  CHANGE_CAMPER = "CHANGE_CAMPER"
}

export enum SearchParentPageEnum {
  CHECK_IN = "CHECK_IN",
  DRUG_ADMIN = "DRUG_ADMIN"
}

export enum TimesOfDayEnum {
  BREAKFAST = "BREAKFAST",
  LUNCH = "LUNCH",
  DINNER = "DINNER",
  BEDTIME = "BEDTIME"
}

export enum ChangeTimeOfDayEnum {
  CHANGE_TIME = "CHANGE_TIME"
}
